export default __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-5355899.f1704114.jpg";